import { Anchor } from "antd";
import { useEffect, useState } from "react";
// import QueueAnim from "rc-queue-anim";
import toRight from "../images/toRight.svg";
import toRightColorful from "../images/toRightColorful.svg";
import useIsMobile from "../hooks/useIsMobile";
import ScrollToTop from "./ScrollToTop";
import AnimatedContent from "./animatedContent/AnimatedContent";
// import ScrollAnim from "rc-scroll-anim";

import "../Ecosystem.css";

const spotDEXList = [
  {
    icon: "/ecosystemIcon/PancakeSwap.svg",
    name: "PancakeSwap",
    desc: "PancakeSwap launched ZK-powered, dynamic trading fees with the Brevis ZK Data Coprocessor, delivering real‑time personalization based on users’ trading history and $CAKE holdings.",
    linkUrl:
      "https://blog.brevis.network/2025/05/12/hook-into-the-future-intelligent-ux-on-pancakeswap-infinity-powered-by-brevis",
  },
  {
    icon: "/ecosystemIcon/Algebra.svg",
    name: "Algebra",
    desc: "Brevis developed a Dynamic Fees Plugin with Algebra that allows DEXes to adjust fees based on traders’ volume, enabling completely trustless user acquisition and retention programs.",
    linkUrl:
      "https://medium.com/@crypto_algebra/algebra-joins-forces-with-brevis-new-integral-plugin-utilizing-the-zk-coprocessor-4cc82712f2e5",
  },
  {
    icon: "/ecosystemIcon/QuickSwap.svg",
    name: "QuickSwap",
    desc: "QuickSwap launched a dynamic fee hook with the Brevis ZK Data Coprocessor that rewards active traders based on their 30‑day volume.",
    linkUrl: "https://x.com/QuickswapDEX/status/1947972378367070555",
  },
  {
    icon: "/ecosystemIcon/THENA.svg",
    name: "THENA",
    desc: "THENA is launching intelligent DEX features supported by Brevis, including token-holding-based fees, volume-based loyalty programs, and smart LP protection against market volatility.",
    linkUrl:
      "https://blog.brevis.network/2024/12/12/thena-partners-with-brevis-to-launch-intelligent-dex-features/",
  },
  {
    icon: "/ecosystemIcon/koalaswap.svg",
    name: "KoalaSwap",
    desc: "KoalaSwap launched fee-based LP rewards on Unit Zero using Brevis Incentra, distributing 2M rewKOALA to liquidity providers based on trading fees generated rather than TVL.",
    linkUrl:
      "https://blog.brevis.network/2025/10/27/koalaswap-launches-2m-rewkoala-lp-rewards-on-unit-zero-powered-by-brevis-incentra/",
  },
  {
    icon: "/ecosystemIcon/Uniswap.svg",
    name: "Uniswap",
    desc: "Uniswap Foundation granted Brevis up to $9M to power the Hooks Routing Rebate program, using ZK proofs to provide verifiable gas rebates for aggregators routing through v4 hooked pools.",
    linkUrl:
      "https://blog.brevis.network/2025/10/24/uniswap-foundation-awards-brevis-grant-for-trustless-routing-rebate-program-up-to-9m/",
  },
  {
    icon: "/ecosystemIcon/Cypher.svg",
    name: "Cypher",
    desc: "Cypher integrates Brevis-powered dynamic fee plugins on Ethereum L1, enabling volume-based discounts, holder rewards, and volatility-adjusted fees verified by ZK proofs.",
    linkUrl: "https://x.com/brevis_zk/status/2011030479399764448",
  },
];
const RWAist = [
  {
    icon: "/ecosystemIcon/OpenEden.svg",
    name: "OpenEden",
    desc: "OpenEden is bringing U.S. Treasury yields on-chain while rewarding real users for genuine engagement with Continuous Protocol Incentivization (CPI).",
    linkUrl:
      "https://blog.brevis.network/2025/07/10/brevis-and-openeden-teaming-up-trustless-zk-powered-rewards-are-coming/",
  },
  {
    icon: "/ecosystemIcon/Usual.svg",
    name: "Usual",
    desc: "Usual is running a $300M/year rewards program powered by Brevis’s trustless calculation and verification, distributing incentives to their stablecoin users across 10+ DeFi markets.",
    linkUrl:
      "https://blog.brevis.network/2024/11/08/say-bye-to-airdrops-say-hi-to-continuous-rewards-how-brevis-and-usual-are-changing-protocol-incentivization-design/",
  },
  {
    icon: "https://s2.coinmarketcap.com/static/img/coins/64x64/36663.png",
    name: "YieldNest",
    desc: "YieldNest launched ZK-verified rewards for ynRWAx holders using Brevis Incentra, distributing based on time-weighted holdings with full on-chain verification",
    linkUrl:
      "https://blog.brevis.network/2025/11/18/yieldnest-launches-incentra-campaign-for-ynrwax-holders/",
  },
  {
    icon: "/ecosystemIcon/USD8.svg",
    name: "USD8",
    desc: "USD8 uses Brevis ProverNet to compute insurance payout eligibility based on time-weighted holding history, enabling fully trustless DeFi coverage without centralized infrastructure.",
    linkUrl:
      "https://blog.brevis.network/2026/01/20/brevis-and-usd8-trustless-insurance-for-defi/",
  },
  {
    icon: "/ecosystemIcon/Matrixdock.png",
    name: "Matrixdock",
    desc: "Matrixdock uses Brevis Incentra to run a dual-reward LP campaign for XAUm, the first LBMA-accredited gold-backed token, distributing trustless rewards to liquidity providers on PancakeSwap based on ZK-verified on-chain activity.",
    linkUrl:
      "https://blog.brevis.network/2026/02/27/matrixdock-launches-dual-reward-gold-lp-campaign-on-pancakeswap-with-incentra/",
  },
];

const ChainList = [
  {
    icon: "/ecosystemIcon/Linea.svg",
    name: "Linea",
    desc: "Linea has partnered with Brevis to empower dApp developers with ZK verifiable computation, seamless UX, and full trustlessness.",
    linkUrl:
      "https://blog.brevis.network/2025/09/02/linea-boosts-growth-with-brevis-zk-powered-linea-ignition-program/",
  },
  {
    icon: "/ecosystemIcon/TAC.svg",
    name: "TAC",
    desc: "TAC launched Brevis-powered Incentra campaigns to bootstrap DeFi liquidity on Telegram, enabling trustless reward distribution for stablecoin bridging and deposits without centralized intermediaries.",
    linkUrl:
      "https://blog.brevis.network/2025/08/25/brevis-now-live-on-tac-enabling-lightning-fast-trustless-and-gas-efficient-defi-for-global-users/",
  },
  {
    icon: "/ecosystemIcon/BNB.svg",
    name: "BNB Chain",
    desc: "BNB Chain integrated Brevis's ZK Data Coprocessor and Pico zkVM to enable smart contracts to access historical data and run complex computations off-chain with on-chain verification, unlocking personalized DeFi and cross-chain security.",
    linkUrl:
      "https://blog.brevis.network/2025/10/10/scaling-bnb-chain-to-infinity-with-verifiable-computing-powered-by-brevis/",
  },
  {
    icon: "/ecosystemIcon/Units.svg",
    name: "Units Network",
    desc: "Units Network deployed Brevis as native infrastructure to power automated, verifiable incentive campaigns across their ecosystem, starting with KoalaSwap's fee-based LP rewards program.",
    linkUrl: "https://x.com/UnitsNetwork/status/1982787835670266061",
  },
  {
    icon: "/ecosystemIcon/CampNetwork.jpeg",
    name: "Camp Network",
    desc: "Camp Network and Brevis are building verifiable IP infrastructure for the AI era, combining Camp's IP-focused L1 with Brevis ZK proofs to cryptographically verify ownership, usage, and compensation flows for AI training data.",
    linkUrl:
      "https://blog.brevis.network/2026/03/31/brevis-and-camp-network-verifiable-ip-for-the-ai-era/",
  },
];

const liquidRestakingist = [
  {
    icon: "/ecosystemIcon/Kernel.svg",
    name: "Kernel",
    desc: "Kernel is enabling cross-chain restaking with Brevis’s ZK proofs to ensure secure, trust-free consensus relay.",
    linkUrl:
      "https://blog.brevis.network/2025/01/23/brevis-and-kernel-enable-cross-chain-restaking-to-expand-bnb-restaked-security/",
  },
  {
    icon: "/ecosystemIcon/Bedrock.svg",
    name: "Bedrock",
    desc: "Bedrock is migrating their PCS trading fee rebate campaign with Brevis support, enabling trustless trade data retrieval and computation.",
    linkUrl:
      "https://blog.brevis.network/2025/09/05/bedrock-x-brevis-rethinking-incentives-in-liquid-restaking/",
  },
  {
    icon: "/ecosystemIcon/Mellow.svg",
    name: "Mellow",
    desc: "Mellow is working with Brevis to explore a trustless loyalty program with verifiable data retrieval, decentralized reward computation, and transparent on-chain claims.",
    linkUrl:
      "https://blog.brevis.network/2025/01/15/mellow-and-brevis-exploring-trustless-loyalty/",
  },
  {
    icon: "/ecosystemIcon/lista.png",
    name: "Lista",
    desc: "Lista launched ZK-verified rewards for their slisBNB/BNB pool on PancakeSwap, distributing LISTA tokens to LPs based on trading fees generated.",
    linkUrl:
      "https://blog.brevis.network/2025/10/17/proving-grounds-partner-lista/",
  },
];
const lendingList = [
  {
    icon: "/ecosystemIcon/Euler.svg",
    name: "Euler",
    desc: "Euler launched a series of Brevis Incentra campaigns that use ZK proofs to verify and trustlessly distribute rewards to vault lenders and borrowers.",
    linkUrl:
      "https://blog.brevis.network/2025/06/30/incentra-launches-with-euler-campaigns-on-arbitrum-trustless-incentive-infrastructure-for-sustained-defi-growth/",
  },
  {
    icon: "/ecosystemIcon/BeraBorrow.svg",
    name: "BeraBorrow",
    desc: "BeraBorrow is integrating with Brevis to introduce Continuous Protocol Incentivization to reward users based on $NECT liquidity provided in proportion to the total $NECT liquidity.",
    linkUrl:
      "https://blog.brevis.network/2025/02/21/brevis-and-beraborrow-are-bringing-continuous-protocol-incentivization-to-berachain/",
  },
  {
    icon: "/ecosystemIcon/Aave.svg",
    name: "Aave",
    desc: "Aave launched a Brevis-powered ZK rewards campaign on Linea offering 2.4% APR on USDC lending/borrowing, calculating and distributing incentives trustlessly based on time-weighted vault shares.",
    linkUrl:
      "https://blog.brevis.network/2025/08/13/setting-a-new-standard-for-on-chain-incentives-with-metamask-linea-and-brevis/",
  },
  {
    icon: "/ecosystemIcon/MendiFinance.jpeg",
    name: "Mendi Finance",
    desc: "Mendi Finance is the first unified liquidity lending protocol powered by ZK proofs, using Brevis ZK Coprocessor to enable intelligent cross-chain lending with on-chain data verification.",
    linkUrl:
      "https://blog.brevis.network/2024/12/20/brevis-partners-with-mendi-to-pioneer-intelligent-lending-solutions/",
  },
  {
    icon: "/ecosystemIcon/TermMax.jpeg",
    name: "TermMax",
    desc: "TermMax uses Brevis Incentra to layer ZK-verified rewards on top of fixed-rate borrowing, bringing trustless reward distribution to fixed-rate lending markets.",
    linkUrl: "https://x.com/brevis_zk/status/2018655716022612269",
  },
];
const perpDEXList = [
  {
    icon: "/ecosystemIcon/Kwenta.svg",
    name: "Kwenta",
    desc: "Kwenta (acquired by Synthetix) launched the world’s first ZK-powered trader loyalty program on perp DEXes, rebating users based on their total trade volume.",
    linkUrl:
      "https://blog.brevis.network/2024/09/09/kwenta-launches-zk-powered-trader-loyalty-program-enabled-by-brevis/",
  },
  {
    icon: "/ecosystemIcon/JOJO.svg",
    name: "JOJO",
    desc: "JOJO launched dynamic funding rates powered by Brevis ZK proofs for perpetual futures trading on Base Chain.",
    linkUrl: "https://cryptobriefing.com/jojo-zk-proofs-technology/",
  },
  {
    icon: "/ecosystemIcon/Aster.svg",
    name: "Aster",
    desc: " Aster DEX integrates Brevis ZK infrastructure to enable CEX-speed trading with cryptographic verification and privacy-preserving position data on their perpetuals and spot platform.",
    linkUrl: "https://x.com/brevis_zk/status/1998664061706453142",
  },
];
const AIList = [
  {
    icon: "/ecosystemIcon/Trusta.svg",
    name: "Trusta",
    desc: "Trusta launched a ZKML MEDIA Score framework supported by Brevis ZK Data Coprocessor, unlocking personalized, data-driven, and privacy-preserving UX in Web3.",
    linkUrl: "https://x.com/brevis_zk/status/1891883192086634516",
  },
  {
    icon: "/ecosystemIcon/Kaito.svg",
    name: "Kaito",
    desc: "Kaito launched the Brevis Yapper Leaderboard combining social mindshare rankings with ZK-powered multipliers that verify on-chain behavior (DeFi activity, token holdings, early adoption) without revealing wallet addresses, enabling privacy-preserving InfoFi rewards.",
    linkUrl:
      "https://blog.brevis.network/2025/09/23/brevis-yapper-leaderboard-launches-on-kaito-privacy-preserving-infofi/",
  },
  {
    icon: "/ecosystemIcon/KiteAI.svg",
    name: "Kite AI",
    desc: "Kite AI integrates Brevis ZK proofs for verifiable AI agent computation, enabling trustless SLA enforcement and micropayment settlement on their AI-native Layer-1.",
    linkUrl: "https://x.com/GoKiteAI/status/1980919102756827321",
  },
  {
    icon: "/ecosystemIcon/Pieverse.svg",
    name: "Pieverse",
    desc: "Pieverse uses Brevis ZK verification to provide AI agents with auditable, compliance-ready payment receipts on BNB Chain, enabling trustless proof of spend for reimbursements and regulatory review.",
    linkUrl: "https://x.com/pieverse_io/status/1984093439194231033",
  },
  {
    icon: "/ecosystemIcon/Vana.svg",
    name: "Vana",
    desc: "Vana integrates Brevis zkTLS and Pico zkVM to enable private AI training on user-owned data, proving data authenticity and computation correctness without exposing raw information while users retain control and earn compensation.",
    linkUrl:
      "https://blog.brevis.network/2025/11/04/brevis-x-vana-enabling-private-data-sovereignty-with-zk-powered-trust/",
  },
  {
    icon: "/ecosystemIcon/UnifAI.svg",
    name: "UnifAI",
    desc: "UnifAI integrates Brevis ZK proofs to enable verifiable autonomous AI agents in DeFi, cryptographically proving strategy execution, agent performance history, and transaction integrity across chains for agentic finance.",
    linkUrl: "https://x.com/brevis_zk/status/1984949083048751239",
  },
];
const privacyList = [
  {
    icon: "/ecosystemIcon/Automata.svg",
    name: "Automata Network",
    desc: "Automata enables confidential ZK proving on Brevis Pico Prism through verifiable TEEs, processing sensitive witness data in hardware-encrypted memory to guarantee privacy without compromising proof validity.",
    linkUrl: "https://x.com/AutomataNetwork/status/1981015929652937039",
  },
  {
    icon: "/ecosystemIcon/Primus.svg",
    name: "Primus",
    desc: "Primus provides zkTLS attestations that prove off-chain data authenticity while keeping sensitive information private, enabling selective disclosure of web data for Brevis-powered applications.",
    linkUrl:
      "https://blog.brevis.network/2026/01/22/brevis-primus-and-trendle-building-verifiable-attention-markets-on-monad/",
  },
  {
    icon: "/ecosystemIcon/0xbow.svg",
    name: "0xbow",
    desc: "0xbow collaborates with Brevis to build privacy pools where users prove eligibility via on-chain provenance or KYC binding before transacting privately on BNB Chain.",
    linkUrl:
      "https://blog.brevis.network/2026/01/15/brevis-x-bnb-chain-redefining-privacy-infrastructure-for-web3/",
  },
  {
    icon: "/ecosystemIcon/BNB.svg",
    name: "BNB Chain",
    desc: "BNB Chain and Brevis are developing generalized privacy infrastructure, building a three-dimensional framework covering what gets protected, how it can be revealed, and who gets access.",
    linkUrl:
      "https://blog.brevis.network/2026/01/15/brevis-x-bnb-chain-redefining-privacy-infrastructure-for-web3/",
  },
];
const securityList = [
  {
    icon: "/ecosystemIcon/GoPlus.svg",
    name: "GoPlus Security",
    desc: "GoPlus Security partners with Brevis to build Security Oracle, delivering ZK-verified risk assessments and security data for DeFi protocols, wallets, and cross-chain applications.",
    linkUrl: "https://x.com/GoPlusSecurity/status/1983449081767936322",
  },
];
const othersList = [
  {
    icon: "/ecosystemIcon/Hemera.svg",
    name: "Hemera",
    desc: "Brevis provides Hemera with seamless access to trust-free historical data, empowering developers to design more innovative dApps.",
    linkUrl: "https://www.thehemera.com/",
  },
  {
    icon: "/ecosystemIcon/0G.svg",
    name: "0G",
    desc: "0G is building a cross-chain data availability layer powered by Brevis zero-knowledge proofs, so that it can take any data stored and stream it to other supported chains.",
    linkUrl:
      "https://blog.brevis.network/2024/06/17/0g-and-brevis-partner-to-enable-trust-free-cross-chain-da/",
  },
  {
    icon: "/ecosystemIcon/ethGas.png",
    name: "ETHGas",
    desc: "ETHGas and Brevis are exploring verifiable gas abstraction through the Open Gas Initiative, using ZK proofs to enable trust-minimized fee payment and settlement across chains.",
    linkUrl:
      "https://blog.brevis.network/2025/12/22/brevis-x-ethgas-exploring-verifiable-gas-abstraction/",
  },
  {
    icon: "/ecosystemIcon/Aperture.png",
    name: "Aperture",
    desc: "Aperture builds autonomous intent-centric DeFi infrastructure with Brevis, using ZK Coprocessor to enable trustless execution of complex user intents across DeFi protocols.",
    linkUrl:
      "https://blog.brevis.network/2024/04/22/the-new-frontier-of-autonomous-intent-centric-defi-the-partnership-between-brevis-and-aperture/",
  },
];
const moreList = [
  {
    icon: "/ecosystemIcon/Celer.svg",
    name: "Celer",
    desc: "",
    linkUrl: "https://celer.network/",
  },
];
const walletList = [
  {
    icon: "/ecosystemIcon/metamaskBlack.svg",
    name: "MetaMask",
    desc: "MetaMask and Linea launched a Brevis-powered ZK rewards campaign offering 2.4% APR on USDC lending/borrowing for eligible card users.",
    linkUrl:
      "https://blog.brevis.network/2025/08/13/setting-a-new-standard-for-on-chain-incentives-with-metamask-linea-and-brevis/",
  },
];
const yieldList = [
  {
    icon: "/ecosystemIcon/beefy.svg",
    name: "Beefy",
    desc: "Beefy launched trustless incentive programs, distributing ZK-verified rewards to LPs in Beefy's active vaults.",
    linkUrl:
      "https://blog.brevis.network/2025/09/15/beefy-%f0%9f%a4%9d-brevis-zk-powered-yield-optimization/",
  },
  {
    icon: "/ecosystemIcon/Turtle.svg",
    name: "Turtle",
    desc: "Turtle works with Brevis to trustlessly calculate and distribute rewards for liquidity in their curated vaults.",
    linkUrl:
      "https://blog.brevis.network/2025/09/02/linea-boosts-growth-with-brevis-zk-powered-linea-ignition-program/",
  },
];

const predictionMarketList = [
  {
    icon: "/ecosystemIcon/Opinion.svg",
    name: "Opinion",
    desc: "Opinion integrates Brevis zkCoprocessor and Pico zkVM to enable trustless prediction market settlement, using zkTLS to prove real-world data authenticity directly from source websites.",
    linkUrl:
      "https://blog.brevis.network/2025/12/18/brevis-brings-trustless-data-to-opinion-the-future-of-prediction-market-settlement/",
  },
  {
    icon: "/ecosystemIcon/APRO.svg",
    name: "APRO",
    desc: "APRO and Brevis are developing trust-free oracle infrastructure and privacy-preserving services for prediction market traders on BNB Chain.",
    linkUrl:
      "https://blog.brevis.network/2026/01/26/brevis-and-apro-trust-free-oracles-and-trader-privacy-for-prediction-markets/",
  },
  {
    icon: "/ecosystemIcon/Trendle.svg",
    name: "Trendle",
    desc: "Trendle uses Brevis Pico zkVM to verifiably calculate their Attention Index, enabling traders to go long or short on social mindshare with cryptographically proven index values.",
    linkUrl:
      "https://blog.brevis.network/2026/01/22/brevis-primus-and-trendle-building-verifiable-attention-markets-on-monad/",
  },
];
const Ecosystem = () => {
  const { isMobile } = useIsMobile();
  // const ScrollOverPack = isMobile ? "div" : ScrollAnim.OverPack;
  const ScrollOverPack = "div";
  const AnimatedWrapper = isMobile ? "div" : AnimatedContent;

  // const MyQueueAnim = isMobile ? "div" : QueueAnim;
  // const str = "Join the proof-powered movement.".toUpperCase();
  // const str4 = "Join the proof-powered".toUpperCase();
  // const str5 = "movement.".toUpperCase();
  // const [proofsGenerated, setProofsGenerated] = useState(58300162);
  // const [uniqueAddresses, setUniqueAddresses] = useState(86759);
  const [isFixed, setIsFixed] = useState(false);
  // const borderColor = [
  //   "#3736DC",
  //   "#F3C208",
  //   "#A489F3",
  //   "#F96E47",
  //   "#F9A6E1",
  //   "#119059",
  //   "#C1D100",
  // ];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "unset";
    document.documentElement.style.overflow = "unset";
  }, []);

  const handleClick = (e, link) => {
    e.preventDefault();
    console.log(link);
  };

  // const getData = () => {
  //   axios
  //     .get("https://explorer-gateway.brevis.network/v1/getAppsOverallData")
  //     .then((res) => {
  //       setProofsGenerated(res.data.totalProofs);
  //       setUniqueAddresses(res.data.totalUniqAddress);
  //       setAppRequests(res.data.totalAppRequests);
  //     });
  // };
  useEffect(() => {
    // getData();
    const dom = document.querySelector(".ant-anchor-wrapper");
    if (!dom || isMobile) {
      return;
    }
    const aaa = dom.getElementsByClassName("ecosystemContentLeftTitle");
    if (dom && aaa.length === 0) {
      const titleDiv = document.createElement("div");
      titleDiv.className = "ecosystemContentLeftTitle";
      titleDiv.textContent = "Ecosystem";
      dom.insertBefore(titleDiv, dom.firstChild);
    }
    // showCircle();
  }, [isMobile]);

  // useEffect(() => {
  //   let base = 500;
  //   function handleResize() {
  //     const windowWidth = window.innerWidth;
  //     console.log("当前窗口宽度:", windowWidth);
  //     if (windowWidth > 1600) {
  //       base = 600;
  //     } else {
  //       base = 500;
  //     }
  //     showCircle(base);
  //     console.log("base999:", base);
  //   }

  //   window.addEventListener("resize", handleResize);
  //   handleResize();
  // }, []);

  // useEffect(() => {
  //   wheelUse();
  // }, []);

  useEffect(() => {
    if (isMobile) {
      return;
    }
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 400
      ) {
        setIsFixed(false);
      } else {
        setIsFixed(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile]);

  return (
    <div className="ecosystem">
      <ScrollToTop />
      <div className="ecosystemContent">
        {/* {!isMobile && (
          <DotGrid
            dotSize={3}
            gap={15}
            baseColor="#eee9c5"
            activeColor="#5227FF"
            proximity={120}
            shockRadius={250}
            shockStrength={5}
            resistance={750}
            returnDuration={1.5}
          />
        )} */}
        <div className="ecosystemContentBody">
          {!isMobile && (
            <div
              className="ecosystemContentLeft"
              key={"test2"}
              style={{ opacity: isFixed ? 1 : 0 }}
            >
              <Anchor
                id="Anchor"
                affix={true}
                onClick={handleClick}
                targetOffset={100}
                offsetTop={100}
                // offsetBottom={1000}
                bounds={400}
                items={[
                  {
                    key: "Wallet",
                    href: "#Wallet",
                    title: (
                      <div className="ecosystemContentLeftListItem">Wallet</div>
                    ),
                  },
                  {
                    key: "SPOT",
                    href: "#SPOT",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Spot DEX
                      </div>
                    ),
                  },
                  {
                    key: "YIELD",
                    href: "#YIELD",
                    title: (
                      <div className="ecosystemContentLeftListItem">Yield</div>
                    ),
                  },
                  {
                    key: "RWA",
                    href: "#RWA",
                    title: (
                      <div className="ecosystemContentLeftListItem">RWA</div>
                    ),
                  },
                  {
                    key: "CHAIN",
                    href: "#CHAIN",
                    title: (
                      <div className="ecosystemContentLeftListItem">Chain</div>
                    ),
                  },
                  {
                    key: "LIQUID",
                    href: "#LIQUID",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Liquid Restaking
                      </div>
                    ),
                  },
                  {
                    key: "LENDING",
                    href: "#LENDING",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Lending
                      </div>
                    ),
                  },
                  {
                    key: "PERP",
                    href: "#PERP",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Perp DEX
                      </div>
                    ),
                  },
                  {
                    key: "AI",
                    href: "#AI",
                    title: (
                      <div className="ecosystemContentLeftListItem">AI</div>
                    ),
                  },
                  {
                    key: "PRIVACY",
                    href: "#PRIVACY",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Privacy
                      </div>
                    ),
                  },
                  {
                    key: "SECURITY",
                    href: "#SECURITY",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Security
                      </div>
                    ),
                  },
                  {
                    key: "PredictionMarket",
                    href: "#PredictionMarket",
                    title: (
                      <div className="ecosystemContentLeftListItem">
                        Prediction Markets
                      </div>
                    ),
                  },
                  {
                    key: "OTHERS",
                    href: "#OTHERS",
                    title: (
                      <div className="ecosystemContentLeftListItem">Others</div>
                    ),
                  },
                ]}
              />
            </div>
          )}

          <div className="ecosystemContentRight">
            <ScrollOverPack
              key={"Wallet"}
              id={"Wallet"}
              playScale={0.05}
              always={true}
            >
              <AnimatedWrapper
                type="bottom"
                id={"Wallet1"}
                key={"WalletIN"}
                duration={800}
              >
                <div key={"WalletIN"} id={"WalletIN"}>
                  <div className="ecoRightTitle" id="WALLET">
                    Wallet
                  </div>
                  <div className="ecosystemContentRightList">
                    {walletList?.map((item, index) => {
                      return (
                        <div
                          className="ecosystemContentRightListItem"
                          key={index}
                          id="arry0"
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img
                              src={item.icon}
                              alt=""
                              style={{
                                width: 48,
                              }}
                            />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"DEX"}
              id={"DEX"}
              playScale={0.05}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"DEXIN"} duration={800}>
                <div key={"DEXIN"} id={"DEXIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="SPOT">
                    Spot DEX
                  </div>
                  <div className="ecosystemContentRightList">
                    {spotDEXList?.map((item, index) => {
                      return (
                        <div
                          className="ecosystemContentRightListItem"
                          key={index}
                          id="arry1"
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"YIELD"}
              id={"YIELD"}
              playScale={0.05}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"YIELDIN"} duration={800}>
                <div key={"YIELDIN"} id={"YIELDIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="SPOT">
                    Yield
                  </div>
                  <div className="ecosystemContentRightList">
                    {yieldList?.map((item, index) => {
                      return (
                        <div
                          className="ecosystemContentRightListItem"
                          key={index}
                          id="arry10"
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"RWA"}
              id={"RWA"}
              playScale={0.16}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"RWAIN"} duration={800}>
                <div key={"RWAIN"} id={"RWAIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="RWA">
                    RWA
                  </div>
                  <div className="ecosystemContentRightList">
                    {RWAist?.map((item, index) => {
                      return (
                        <div
                          id="arry2"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"CHAIN"}
              id={"CHAIN"}
              playScale={0.16}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"CHAIN"} duration={800}>
                <div key={"CHAIN"} id={"CHAIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="CHAIN">
                    Chain
                  </div>
                  <div className="ecosystemContentRightList">
                    {ChainList?.map((item, index) => {
                      return (
                        <div
                          id="arry1"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"LIQUID1"}
              id={"LIQUID"}
              playScale={0.18}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"LIQUIDIN"} duration={800}>
                <div key={"LIQUIDIN"} id={"LIQUIDIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="LIQUID1">
                    Liquid Restaking
                  </div>
                  <div className="ecosystemContentRightList">
                    {liquidRestakingist?.map((item, index) => {
                      return (
                        <div
                          id="arry3"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"LENDING"}
              id={"LENDING"}
              playScale={0.2}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"LENDINGIN"} duration={800}>
                <div key={"LENDINGIN"} id={"LENDINGIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="LENDING1">
                    Lending
                  </div>
                  <div className="ecosystemContentRightList">
                    {lendingList?.map((item, index) => {
                      return (
                        <div
                          id="arry4"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"PERP"}
              id={"PERP"}
              playScale={0.22}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"PERPIN"} duration={800}>
                <div key={"PERPIN"} id={"PERPIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="PERP1">
                    Perp DEX
                  </div>
                  <div className="ecosystemContentRightList">
                    {perpDEXList?.map((item, index) => {
                      return (
                        <div
                          id="arry5"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack key={"AI"} id={"AI"} playScale={0.23} always={true}>
              <AnimatedWrapper type="bottom" key={"AIIN"} duration={800}>
                <div key={"AIIN"} id={"AIIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="AI1">
                    AI
                  </div>
                  <div className="ecosystemContentRightList">
                    {AIList?.map((item, index) => {
                      return (
                        <div
                          id="arry6"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
            <ScrollOverPack
              key={"PRIVACY"}
              id={"PRIVACY"}
              playScale={0.24}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"PRIVACYIN"} duration={800}>
                <div key={"PRIVACYIN"} id={"PRIVACYIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="PRIVACY1">
                    Privacy
                  </div>
                  <div className="ecosystemContentRightList">
                    {privacyList?.map((item, index) => {
                      return (
                        <div
                          className="ecosystemContentRightListItem"
                          key={index}
                          id="arry8"
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>

            <ScrollOverPack
              key={"SECURITY"}
              id={"SECURITY"}
              playScale={0.24}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"SECURITYIN"} duration={800}>
                <div
                  key={"SECURITYIN"}
                  id={"SECURITYIN"}
                  className="ecoItemOut"
                >
                  <div className="ecoRightTitle" id="SECURITY1">
                    Security
                  </div>
                  <div className="ecosystemContentRightList">
                    {securityList?.map((item, index) => {
                      return (
                        <div
                          className="ecosystemContentRightListItem"
                          key={index}
                          id="arry9"
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>

            <ScrollOverPack
              key={"PredictionMarket"}
              id={"PredictionMarket"}
              playScale={0.24}
              always={true}
            >
              <AnimatedWrapper
                type="bottom"
                key={"PredictionMarketIN"}
                duration={800}
              >
                <div
                  key={"PredictionMarketIN"}
                  id={"PredictionMarketIN"}
                  className="ecoItemOut"
                >
                  <div className="ecoRightTitle" id="PredictionMarket1">
                    Prediction Markets
                  </div>
                  <div className="ecosystemContentRightList">
                    {predictionMarketList?.map((item, index) => {
                      return (
                        <div
                          className="ecosystemContentRightListItem"
                          key={index}
                          id="arry7"
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>

            <ScrollOverPack
              key={"OTHERS"}
              id={"OTHERS"}
              playScale={0.24}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"OTHERSIN"} duration={800}>
                <div key={"OTHERSIN"} id={"OTHERSIN"} className="ecoItemOut">
                  <div className="ecoRightTitle" id="OTHERS1">
                    Others
                  </div>
                  <div className="ecosystemContentRightList">
                    {othersList?.map((item, index) => {
                      return (
                        <div
                          id="arry8"
                          className="ecosystemContentRightListItem"
                          key={index}
                        >
                          <div className="ecosystemContentRightListItemTop">
                            <img src={item.icon} alt="" style={{ width: 48 }} />
                            <div className="ecoListItemTopText">
                              {item.name}
                            </div>
                            <div className="placeLinear1" />
                            <div className="placeLinear2" />
                          </div>
                          <div className="ecoItemBottom">
                            <div className="ecoListItemTopTextDesc">
                              {item.desc}
                            </div>
                            <div
                              className="ecoListItemTopLink"
                              onClick={() => {
                                window.open(item.linkUrl, "_blank");
                              }}
                            >
                              <img src={toRight} className="toRight" alt="" />
                              <img
                                src={toRightColorful}
                                className="toRight"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>

            <ScrollOverPack
              key={"moreOut"}
              id={"moreOut"}
              playScale={0.25}
              always={true}
            >
              <AnimatedWrapper type="bottom" key={"moreb"} duration={800}>
                <div key="more" id="more" className="ecoItemOut">
                  <div className="ecoRightTitle">
                    {/* More use cases coming soon... */}
                    More use cases coming soon...
                  </div>
                  <div className="ecosystemContentRightList">
                    {moreList?.map((item, index) => {
                      return (
                        <div className="ecoMoreListItem" key={index}>
                          <div className="ecoMoreListItemTop">
                            <img
                              src={item.icon}
                              className="icon"
                              alt=""
                              style={{ width: 60 }}
                            />
                            <div className="ecoMoreText">{item.name}</div>
                          </div>
                          <div
                            className="ecoMoreLink"
                            onClick={() => {
                              window.open(item.linkUrl, "_blank");
                            }}
                          >
                            <img src={toRight} className="moreToRight" alt="" />
                            <img
                              src={toRightColorful}
                              className="moreToRight"
                              alt=""
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </AnimatedWrapper>
            </ScrollOverPack>
          </div>
        </div>
      </div>
      {/* <PixelCard
        className="join-spotlight-card"
        spotlightColor="rgba(55, 54, 220, 0.7)"
      > */}
      {/* <div className="join">
        {!isMobile && (
          <DotGrid
            dotSize={3}
            gap={15}
            baseColor="#38363a"
            activeColor="#5227FF"
            proximity={120}
            shockRadius={250}
            shockStrength={5}
            resistance={750}
            returnDuration={1.5}
          />
        )}
        <div className="join_body">
          <ScrollOverPack
            key={"join"}
            id={"introduce"}
            playScale={0.35}
            appear={!isMobile}
            always={!isMobile}
          >
            <MyQueueAnim type="bottom" duration={1500}>
              <div className="join_title" key="join_title">
                {isMobile ? (
                  <div>
                    <div>{str4}</div>
                    <div>{str5}</div>
                  </div>
                ) : (
                  <div>
                    <SplitText
                      text={str}
                      className="text-2xl font-semibold text-center"
                      delay={20}
                      animationFrom={{
                        opacity: 0,
                        transform: "translate3d(0,50px,0)",
                      }}
                      animationTo={{
                        opacity: 1,
                        transform: "translate3d(0,0,0)",
                      }}
                      easing="easeOutCubic"
                      threshold={0.2}
                      rootMargin="-50px"
                      onLetterAnimationComplete={() => {}}
                    />
                  </div>
                )}
              </div>
            </MyQueueAnim>

            <MyQueueAnim type="bottom" duration={1500} delay={600}>
              <div className="join_buttons" key={"helpYou_buttons"}>
                <div
                  className={isMobile ? "join_button2" : "join_button2"}
                  onClick={() => {
                    window.open("https://blog.brevis.network/", "_blank");
                  }}
                >
                  Read Case Studies
                </div>
                <div
                  className={isMobile ? "join_button" : "join_button"}
                  onClick={() => {
                    window.open(
                      "https://form.typeform.com/to/lduiliob",
                      "_blank"
                    );
                  }}
                  style={isMobile ? { color: "rgba(255, 252, 228, 1)" } : {}}
                >
                  Join
                </div>
              </div>
            </MyQueueAnim>
          </ScrollOverPack>
        </div>
      </div> */}
      {/* </PixelCard> */}
    </div>
  );
};
export default Ecosystem;
